'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _backdraftJs = require('backdraft-js');

var _backdraftJs2 = _interopRequireDefault(_backdraftJs);

var _utilsFont = require('./utils/font');

var _utilsFont2 = _interopRequireDefault(_utilsFont);

var markup = {
	'BOLD': ['<strong>', '</strong>'],
	'ITALIC': ['<em>', '</em>']
};

var RichTextRenderer = function RichTextRenderer(props) {

	var style = props.style || {};

	(0, _utilsFont2['default'])(style, props.font);

	//size
	if (props.height) style.height = props.height;
	if (props.width) style.width = props.width;

	var htmlContentArray = props.content !== undefined ? (0, _backdraftJs2['default'])(props.content, markup) : ["type your content"];

	return _react2['default'].createElement(
		'div',
		{ style: style },
		htmlContentArray.map(function (htmlContent, i) {
			if (htmlContent === "") htmlContent += "<BR />";
			return _react2['default'].createElement('div', { key: "h" + i, dangerouslySetInnerHTML: { __html: htmlContent } });
		})
	);
};

//RichEditorRenderer.defaultProps = {content:'type your content'};
exports['default'] = RichTextRenderer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/widgets/RichTextRenderer.js
 ** module id = 2224
 ** module chunks = 0
 **/